"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OldDatasController", {
    enumerable: true,
    get: function() {
        return OldDatasController;
    }
});
const _common = require("@nestjs/common");
const _olddatasservice = require("./old-datas.service");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _dataapilimiterguard = require("~/guards/data-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let OldDatasController = class OldDatasController {
    async dataList(context, req, res, baseId, tableName) {
        res.json(await this.oldDatasService.dataList(context, {
            query: req.query,
            baseId: baseId,
            tableName: tableName
        }));
    }
    async dataCount(context, req, res, baseId, tableName) {
        res.json(await this.oldDatasService.dataCount(context, {
            query: req.query,
            baseId: baseId,
            tableName: tableName
        }));
    }
    async dataInsert(context, req, res, baseId, tableName, body) {
        res.json(await this.oldDatasService.dataInsert(context, {
            baseId: baseId,
            tableName: tableName,
            body: body,
            cookie: req
        }));
    }
    async dataRead(context, req, res, baseId, tableName, rowId) {
        res.json(await this.oldDatasService.dataRead(context, {
            baseId: baseId,
            tableName: tableName,
            rowId: rowId,
            query: req.query
        }));
    }
    async dataUpdate(context, req, res, baseId, tableName, rowId) {
        res.json(await this.oldDatasService.dataUpdate(context, {
            baseId: baseId,
            tableName: tableName,
            body: req.body,
            cookie: req,
            rowId: rowId
        }));
    }
    async dataDelete(context, req, res, baseId, tableName, rowId) {
        res.json(await this.oldDatasService.dataDelete(context, {
            baseId: baseId,
            tableName: tableName,
            cookie: req,
            rowId: rowId
        }));
    }
    constructor(oldDatasService){
        this.oldDatasService = oldDatasService;
    }
};
_ts_decorate([
    (0, _common.Get)('/nc/:baseId/api/v1/:tableName'),
    (0, _extractidsmiddleware.Acl)('dataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Request)()),
    _ts_param(2, (0, _common.Response)()),
    _ts_param(3, (0, _common.Param)('baseId')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        void 0,
        void 0,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OldDatasController.prototype, "dataList", null);
_ts_decorate([
    (0, _common.Get)('/nc/:baseId/api/v1/:tableName/count'),
    (0, _extractidsmiddleware.Acl)('dataCount'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Request)()),
    _ts_param(2, (0, _common.Response)()),
    _ts_param(3, (0, _common.Param)('baseId')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        void 0,
        void 0,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OldDatasController.prototype, "dataCount", null);
_ts_decorate([
    (0, _common.Post)('/nc/:baseId/api/v1/:tableName'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('dataInsert'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Request)()),
    _ts_param(2, (0, _common.Response)()),
    _ts_param(3, (0, _common.Param)('baseId')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_param(5, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        void 0,
        void 0,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], OldDatasController.prototype, "dataInsert", null);
_ts_decorate([
    (0, _common.Get)('/nc/:baseId/api/v1/:tableName/:rowId'),
    (0, _extractidsmiddleware.Acl)('dataRead'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Request)()),
    _ts_param(2, (0, _common.Response)()),
    _ts_param(3, (0, _common.Param)('baseId')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_param(5, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        void 0,
        void 0,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OldDatasController.prototype, "dataRead", null);
_ts_decorate([
    (0, _common.Patch)('/nc/:baseId/api/v1/:tableName/:rowId'),
    (0, _extractidsmiddleware.Acl)('dataUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Request)()),
    _ts_param(2, (0, _common.Response)()),
    _ts_param(3, (0, _common.Param)('baseId')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_param(5, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        void 0,
        void 0,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OldDatasController.prototype, "dataUpdate", null);
_ts_decorate([
    (0, _common.Delete)('/nc/:baseId/api/v1/:tableName/:rowId'),
    (0, _extractidsmiddleware.Acl)('dataDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Request)()),
    _ts_param(2, (0, _common.Response)()),
    _ts_param(3, (0, _common.Param)('baseId')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_param(5, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        void 0,
        void 0,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OldDatasController.prototype, "dataDelete", null);
OldDatasController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_dataapilimiterguard.DataApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _olddatasservice.OldDatasService === "undefined" ? Object : _olddatasservice.OldDatasService
    ])
], OldDatasController);
